import { Language } from '../../enums/language.enum';
import { allTranslatedPathRecords } from '../translated-paths';

export function checkIfPathExistsForLanguage(path: string, language: Language): boolean {
	const allPathsForLanguage = allTranslatedPathRecords.reduce((paths, translatedPathRecord) => {
		const translatedPath = translatedPathRecord[language];
		paths.push(translatedPath);

		return paths;
	}, [] as string[]);

	return allPathsForLanguage.includes(path);
}
